module.exports = __webpack_public_path__ + "img/03.aaa1c5cd.jpg";